import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./context/CartContext";
import { AuthProvider, ProtectedRoute } from "./context/AuthContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { CartDrawer } from "./components/CartDrawer";
import { CookieBanner } from "./components/CookieBanner";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import ProductPage from "./pages/ProductPage";
import Checkout from "./pages/Checkout";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import Account, { ResetPassword } from "./pages/Account";
import OrderTrack from "./pages/OrderTrack";
import Markets from "./pages/Markets";
import Contact from "./pages/Contact";
import About from "./pages/About";
import LegalPage from "./pages/LegalPage";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const ShopLayout = () => (
  <>
    <Header />
    <main className="min-h-[60vh]"><Outlet /></main>
    <Footer />
    <CartDrawer />
    <CookieBanner />
  </>
);

const LEGAL_ROUTES = ["livraison-retours", "cgv", "mentions-legales", "confidentialite", "cookies", "retractation"];

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <ScrollTop />
          <Routes>
            <Route element={<ShopLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/boutique" element={<Catalog />} />
              <Route path="/categorie/:slug" element={<Catalog />} />
              <Route path="/parfum/:slug" element={<ProductPage />} />
              <Route path="/commande" element={<Checkout />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/compte" element={<Account />} />
              <Route path="/compte/reinitialiser" element={<ResetPassword />} />
              <Route path="/suivi/:orderNumber" element={<OrderTrack />} />
              <Route path="/marches" element={<Markets />} />
              <Route path="/a-propos" element={<About />} />
              {LEGAL_ROUTES.map((r) => <Route key={r} path={`/${r}`} element={<LegalPage page={r} />} />)}
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/admin/connexion" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" toastOptions={{ style: { background: "#141414", border: "1px solid rgba(201,164,92,.35)", color: "#F8F6F1" } }} />
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
